/*
 * NextGenn engine · the photograph you can shop (sections/ngs-hotspots.liquid).
 *
 * One card showing at a time, the mark that opened it held lit, and everything
 * shut by Escape or by a press anywhere off it. That is the whole of it: the
 * cards are already in the page, written by Liquid, so this file never composes
 * a price or a name and cannot get one wrong.
 *
 * WITHOUT THIS FILE THE SECTION STILL WORKS: each mark is a button inside a
 * section whose cards are plain markup, and the bottle's name inside the card
 * is a real link. Nothing here is the only way to reach anything.
 */
if (!customElements.get('ngs-hotspots')) {
  customElements.define(
    'ngs-hotspots',
    class NGSHotspots extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.marks = Array.prototype.slice.call(this.querySelectorAll('[data-spot]'));
        this.tray = this.querySelector('[data-ngs-tray]');
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-card]'));
        if (!this.marks.length || !this.tray) return;

        /* THE CARDS ARE INSIDE A HIDDEN TRAY, AND A HIDDEN IMAGE NEVER LOADS.
           A lazy image inside `display: none` does not start fetching until it
           is shown, so the card rose with an empty square in it and the bottle
           appeared a beat later — on the one screen where the customer has just
           pointed at that exact bottle. The pictures are warmed into the cache
           as the photograph comes near, which costs nothing until then and
           nothing at all if the browser is old. */
        this.warm();

        this.onClick = this.onClick.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onAway = this.onAway.bind(this);
        this.addEventListener('click', this.onClick);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onAway);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onAway);
      }

      warm() {
        if (!('IntersectionObserver' in window)) return;
        var cards = this.cards;
        var watcher = new IntersectionObserver(
          function (entries) {
            if (!entries.some(function (e) { return e.isIntersecting; })) return;
            cards.forEach(function (card) {
              var img = card.querySelector('img');
              var src = img && img.getAttribute('src');
              if (!src) return;
              var pre = new Image();
              pre.src = src;
            });
            watcher.disconnect();
          },
          { rootMargin: '400px 0px' }
        );
        watcher.observe(this);
      }

      onClick(event) {
        var target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (target.closest('[data-ngs-shut]')) {
          this.shut();
          return;
        }
        var mark = target.closest('[data-spot]');
        if (!mark) return;
        if (mark.getAttribute('aria-expanded') === 'true') {
          this.shut();
          return;
        }
        this.open(mark.dataset.spot);
      }

      onKey(event) {
        if (event.key === 'Escape') this.shut();
      }

      /* A press anywhere else on the page shuts it, the way every card that
         rises over a picture has always behaved. A press inside it does not. */
      onAway(event) {
        if (!this.open_) return;
        if (event.target instanceof Element && this.contains(event.target)) return;
        this.shut();
      }

      open(id) {
        this.open_ = id;
        this.marks.forEach(function (mark) {
          mark.setAttribute('aria-expanded', String(mark.dataset.spot === id));
        });
        this.cards.forEach(function (card) {
          card.hidden = card.dataset.card !== id;
        });
        this.tray.hidden = false;
        this.tray.classList.add('is-up');
      }

      shut() {
        this.open_ = null;
        this.marks.forEach(function (mark) {
          mark.setAttribute('aria-expanded', 'false');
        });
        this.tray.classList.remove('is-up');
        /* Hidden only after it has finished sliding down, or it vanishes. */
        var tray = this.tray;
        var cards = this.cards;
        window.setTimeout(function () {
          if (tray.classList.contains('is-up')) return;
          tray.hidden = true;
          cards.forEach(function (card) {
            card.hidden = true;
          });
        }, 320);
      }
    }
  );
}
